import React from "react";
import { Typography } from "@mui/material";

export const ErrorText = ({ text, marginTop = 0 }: { text: string; marginTop?: number }) => (
  <Typography component="div" marginTop={marginTop} color="error.main" variant="main">
    {text}
  </Typography>
);
